const mapStateToClassName = (props) => {
  return [
    ...[!props.isValid && 'invalid'],
    ...[props.isValid && 'valid'],
    ...[props.isEmpty && 'empty'],
    ...[props.isTouched && 'touched'],
    ...[props.isDirty && 'dirty'],
  ]
    .filter(Boolean)
    .join(' ');
};

export default mapStateToClassName;
